import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function createPasswordValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;

		if (!value) {
			return null;
		}

		const hasUpperCase = /[A-Z]/.test(value);
		const hasLowerCase = /[a-z]/.test(value);
		const hasNumber = /[0-9]/.test(value);
		const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
		const hasMinLength = value.length >= 8;

		const errors: ValidationErrors = {};

		if (!hasMinLength) {
			errors['passwordLength'] = true;
		}
		if (!hasUpperCase) {
			errors['passwordUpperCase'] = true;
		}
		if (!hasLowerCase) {
			errors['passwordLowerCase'] = true;
		}
		if (!hasNumber) {
			errors['passwordNumber'] = true;
		}
		if (!hasSpecialChar) {
			errors['passwordSpecialChar'] = true;
		}

		return Object.keys(errors).length > 0 ? errors : null;
	};
}
